import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Trophy, Loader2 } from 'lucide-react';

export const SpawnChildDialog = ({
  open, onOpenChange,
  title, setTitle,
  ranking = [], judgesCount = 0,
  startupIds, toggleStartup,
  onConfirm, spawning,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-card border-white/10">
        <DialogHeader><DialogTitle>Crea Round Successivo</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1">
            <Label>Titolo nuova challenge *</Label>
            <Input
              data-testid="spawn-title-input"
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="Es. Finale 2026"
              className="bg-white/5 border-white/10"
            />
            <p className="text-xs text-muted-foreground">
              I giurati verranno copiati dalla challenge corrente. Data e ora si impostano dopo la creazione (resta in bozza).
            </p>
          </div>
          <div className="space-y-2">
            <Label>Startup da portare al round successivo *</Label>
            <div className="max-h-64 overflow-y-auto space-y-1 p-2 bg-white/5 rounded-lg border border-white/10">
              {ranking.map(r => (
                <label
                  key={r.startup_id}
                  className="flex items-center gap-3 p-2 rounded hover:bg-white/5 cursor-pointer"
                  data-testid={`spawn-startup-option-${r.startup_id}`}
                >
                  <input
                    type="checkbox"
                    checked={startupIds.includes(r.startup_id)}
                    onChange={() => toggleStartup(r.startup_id)}
                    className="rounded border-white/20"
                  />
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                    r.position === 1 ? 'bg-yellow-500/20 text-yellow-400' :
                    r.position === 2 ? 'bg-gray-400/20 text-gray-300' :
                    r.position === 3 ? 'bg-orange-500/20 text-orange-400' :
                    'bg-white/10 text-muted-foreground'
                  }`}>{r.position}</span>
                  {r.startup_logo
                    ? <img
                        src={r.startup_logo.startsWith('http') ? r.startup_logo : `${process.env.REACT_APP_BACKEND_URL}${r.startup_logo}`}
                        alt=""
                        className="w-7 h-7 rounded object-contain bg-white/10 p-0.5"
                      />
                    : <div className="w-7 h-7 rounded bg-primary/20" />}
                  <span className="flex-1 text-sm truncate">{r.startup_name}</span>
                  <span className="text-xs text-primary font-bold">{r.votes} voti</span>
                </label>
              ))}
              {ranking.length === 0 && (
                <p className="text-center text-xs text-muted-foreground py-4">Nessun voto registrato nella challenge padre</p>
              )}
            </div>
            <p className="text-xs text-muted-foreground">
              {startupIds.length} startup selezionate · {judgesCount} giurati verranno copiati
            </p>
          </div>
          <div className="flex justify-end gap-2 pt-3 border-t border-white/10">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
            <Button
              onClick={onConfirm}
              disabled={spawning || !title.trim() || startupIds.length === 0}
              data-testid="spawn-confirm-btn"
            >
              {spawning ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Trophy size={14} className="mr-1" />}
              Crea Round
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
